import React from 'react'
import DNavbar from '../Components/Downtown/DNavbar/DNavbar'
import DHeader from '../Components/Downtown/DHeader/DHeader'
import Residency from '../Components/Downtown/Residency/Residency'
import International from '../Components/Downtown/International/International'
import Premiumresidences from "../Components/Downtown/PremiumResidences/Premiumresidences"
// import ResidencePlan from "../Components/Downtown/ResidencePlan/ResidencePlan"
import Services from '../Components/Downtown/Services/Services'
import Amenities from "../Components/Downtown/Amenities/Amenities"
import Surrounding from '../Components/Downtown/Surrounding/Surrounding'
import Footer from '../Components/Downtown/Footer/Footer'


const Downtown = () => {
  return (
    <div>
      <DNavbar />
      <DHeader />
      <Residency />
      <International />
      <Premiumresidences />
      <Services />
      <Amenities />
      <Surrounding />
      <Footer />
      </div>
    )
  }
  
  export default Downtown